import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

const useOpenAiStatus = () => {
  const { data: isOpenAiDown } = useQuery<boolean>(
    ['open-ai-is-down'],
    async () => await backendService.instance.ai.getStatus(),
    { staleTime: 1000 * 60 },
  );
  return isOpenAiDown === true;
};

export default useOpenAiStatus;
